module.exports = __webpack_public_path__ + "img/eye.6cc7ff4c.svg";